const MAX_LENGTH_COMPANY_NAME = 50;
const MAX_LENGTH_PRODUCT_NAME = 24;

export {
  MAX_LENGTH_COMPANY_NAME,
  MAX_LENGTH_PRODUCT_NAME
}
